import axios from 'axios';
import HttpErrorResponseModel from '../models/HttpErrorResponseModel';

const RequestMethod = {
  Get: 'GET',
  Post: 'POST',
  Put: 'PUT',
  Delete: 'DELETE',
  Options: 'OPTIONS',
  Head: 'HEAD',
  Patch: 'PATCH'
};

export async function get(endpoint, headers, params) {
  const config = params ? {params} : undefined;
  return _request(
    {
      url: endpoint,
      method: RequestMethod.Get
    },
    config,
    headers
  );
}

export async function post(endpoint, headers, data) {
  const config = data ? {data} : undefined;
  return _request(
    {
      url: endpoint,
      method: RequestMethod.Post
    },
    config,
    headers
  );
}

export async function put(endpoint, headers, data) {
  const config = data ? {data} : undefined;
  return _request(
    {
      url: endpoint,
      method: RequestMethod.Put
    },
    config,
    headers
  );
}

export async function del(endpoint, headers) {
  return _request({
      url: endpoint,
      method: RequestMethod.Delete
    },
    {},
    headers
  );
}

export async function _request(restRequest, config, headers) {
  if (!Boolean(restRequest.url)) {
    console.error(`Received ${restRequest.url} which is invalid for a endpoint url`);
  }

  try {
    const axiosRequestConfig = {
      ...config,
      method: restRequest.method,
      url: restRequest.url,
      headers: {
        'Content-Type': 'application/json',
        ...headers
      }
    };
    const [axiosResponse] = await Promise.all([axios(axiosRequestConfig), _delay()]);

    const {status, data, request} = axiosResponse;

    if (data.success === false) {
      return _fillInErrorWithDefaults(
        {
          status,
          message: data.errors.join(' - '),
          errors: data.errors,
          url: request ? request.responseURL : restRequest.url,
          raw: axiosResponse
        },
        restRequest
      );
    }

    return {
      ...axiosResponse
    };
  } catch (error) {    
    if (error.response && error.response.data) {
      // The request was made and the server responded with a specific status code
      const {status, data} = error.response;
      const errors = data.hasOwnProperty('errors') ? [data.message, ...data.errors] : [data.message];

      return _fillInErrorWithDefaults(
        {
          status,
          message: data.message ? data.message : "Error requesting the data!",
          code: data.code ? data.code : error.code,
          errors: data.message ? errors : [error.message],
          url: error.request.responseURL,
          raw: error.response
        },
        restRequest
      );
    } else {
      // Something happened (e.g network error, request didn't reach the server)
      return _fillInErrorWithDefaults(
        {
          status: 0,
          message: "Error requesting the data!",
          errors: [error.message],
          url: restRequest.url,
          raw: error
        },
        restRequest
      );
    }
  }
}

function _fillInErrorWithDefaults(error, request) {
  const model = new HttpErrorResponseModel();

  model.status = error.status || 0;
  model.message = error.message || 'Error requesting data';
  model.errors = error.errors.length ? error.errors : ['Error requesting data'];
  model.url = error.url || request.url;
  model.raw = error.raw;

  // Remove anything with undefined or empty strings.
  model.errors = model.errors.filter(Boolean);

  return model;
}

/**
 * We want to show the loading indicator to the user but sometimes the api
 * request finished too quickly. This makes sure there the loading indicator is
 * visual for at least a given time.
 *
 * @param duration
 * @returns {Promise<void>}
 * @private
 */
function _delay(duration = 250) {
  return new Promise((resolve) => setTimeout(resolve, duration));
}
